"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Domains = void 0;
exports.getPublishedPaths = getPublishedPaths;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _utils = require("./utils");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

function apiFetch(_x) {
  return _apiFetch.apply(this, arguments);
}
/**
 * Fetch all published learning paths for the domain
 * @returns Promise resolving to an array of published learning paths
 * @example
 * const paths = await ChWebSdk.Domains.getPublishedPaths()
 */


function _apiFetch() {
  _apiFetch = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path) {
    var response;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if ((0, _utils.isBrowser)()) {
              _context.next = 2;
              break;
            }

            throw new Error('Domains SDK methods can only be called in a browser environment');

          case 2:
            _context.next = 4;
            return fetch((0, _absoluteUrlRuntime.resolveUrl)(path, _absoluteUrlRuntime.UrlSourceType.Api));

          case 4:
            response = _context.sent;

            if (response.ok) {
              _context.next = 7;
              break;
            }

            throw new Error("Domains API request failed: ".concat(response.statusText));

          case 7:
            return _context.abrupt("return", response.json());

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _apiFetch.apply(this, arguments);
}

function getPublishedPaths() {
  return _getPublishedPaths.apply(this, arguments);
}
/**
 * Domains bounded context
 */


function _getPublishedPaths() {
  _getPublishedPaths = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
    var _data$results;

    var data;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return apiFetch('/customerEducation/publishedPaths');

          case 2:
            data = _context2.sent;
            return _context2.abrupt("return", (_data$results = data.results) !== null && _data$results !== void 0 ? _data$results : []);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getPublishedPaths.apply(this, arguments);
}

var Domains = {
  getPublishedPaths: getPublishedPaths
};
exports.Domains = Domains;